export default __webpack_public_path__ + "static/media/warehouse.a3b55bac.png";